import production from '../../production/common/main.js'

export default {
  ...production,
  base_api_url: 'http://localhost:3003',
  operation_email: 'kaplanharel@gmail.com',
}
